export default __webpack_public_path__ + "static/media/Locked.fed31a75.jpg";